<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12 sm7>
                            <h1>Баланс</h1>
                        </v-flex>
                        <v-flex xs12 sm5 style="text-align: right; padding-top: 40px">
                            <span style="font-size: 18px;">Доступно к выводу:
                                <span style="padding-left: 20px; font-size: 40px; font-weight: 700">
                                    {{ this.balance + '\xa0₽'}}
                                </span>
                            </span>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container style="max-width: 1800px;">
                    <v-layout pt-4 pb-4 row wrap>
                        <v-flex xs12 sm6 md8>
                            <v-text-field
                                py-5
                                v-model="filters.search"
                                prepend-inner-icon="search"
                                label="Поиск по ФИО"
                                single-line
                                hide-details
                                @keydown.enter="newSearch"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <v-btn
                                class="submit-button block"
                                @click="newSearch">Поиск</v-btn>
                        </v-flex>
                        <v-flex v-if="isAdmin || isCurator || !isPhysical" xs12 sm3 md2 pt-4>
                            <b2b-pay-commission-dialog
                                :agents="usersWithCommission"
                                :is-loading-agents-filter="isLoadingAgentsFilter"
                                :type="role"
                                :balance="userBalance"
                                @paymentCreated="onPaymentCreated"
                            />
                        </v-flex>
                    </v-layout>

                    <h3 class="py-0">Фильтры</h3>
                    <v-layout py-0 row wrap class="filters">
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Период, от"
                                v-model="filters.period_from"
                                :max="filters.period_to"
                                :yearStarting="false"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Период, до"
                                v-model="filters.period_to"
                                :min="filters.period_from"
                                :yearStarting="false"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 py0>
                            <v-select
                                v-model="filters.service"
                                ref="filterService"
                                :items="servicesList"
                                item-value="id"
                                item-text="name"
                                label="Услуга"
                                hide-no-data
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <v-text-field
                                class="remove-arrows"
                                label="Сумма, от"
                                v-model="filters.sum_from"
                                min="0"
                                :max="filters.sum_to ? filters.sum_to : 999999"
                                mask="######"
                                type="number"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <v-text-field
                                class="remove-arrows"
                                label="Сумма, до"
                                v-model="filters.sum_to"
                                :min="filters.sum_from ? filters.sum_from : 0"
                                max="999999"
                                mask="######"
                                type="number"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 py0 v-if="showCurators">
                            <v-autocomplete
                                v-model="filters.curator"
                                ref="filterCurator"
                                label="Куратор"
                                :items="curatorsList"
                                :loading="isLoadingCuratorsFilter"
                                item-value="id"
                                item-text="name"
                                placeholder="Введите ФИО или email"
                                hide-no-data
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:item="data">
                                    <v-list-tile-content v-text="data.item.name + ' ' + data.item.weekly_balance + ' ₽'"/>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 py0 v-if="showAgents">
                            <v-autocomplete
                                v-model="filters.agent"
                                ref="filterAgent"
                                label="Пользователь"
                                :items="agentsList"
                                :loading="isLoadingAgentsFilter"
                                item-value="id"
                                item-text="name"
                                placeholder="Введите ФИО или email"
                                hide-no-data
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:item="data">
                                    <v-list-tile-content v-text="data.item.name + ' ' + data.item.weekly_balance + ' ₽'"/>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout pt-0 pb-5 row wrap>
                        <v-flex xs10>
                            <a @click="cleanFilters" class="link">Очистить все</a>
                        </v-flex>
                        <v-flex xs2>
                            <download-excel
                                name="agents-list.xls"
                                worksheet="Пользователи"
                                :fetch="downloadItems"
                                :fields="downloadFields"
                            >
                                <a class="link">Выгрузить результат</a>
                            </download-excel>
                        </v-flex>
                    </v-layout>

                    <v-tabs
                        v-model="tab"
                        slider-color="#000"
                        show-arrows
                    >
                        <v-tab v-for="(tab, index) in tabsList" :key="index"
                               @click="changeTab(index)"
                        >
                            {{ tab }}
                        </v-tab>
                    </v-tabs>

                    <v-data-table
                        py-5
                        ref="accountingListTable"
                        v-model="selected"
                        :headers="headers"
                        :items="rows"
                        :pagination.sync="pagination"
                        :total-items="totalRows"
                        :loading="loading"
                        item-key="0"
                        :rows-per-page-items="[10,25,50]"
                        rows-per-page-text="Показывать по"
                        :no-data-text="loading ? 'Загрузка данных...' : 'Нет данных'"
                        no-results-text="Ничего не найдено"
                    >
                        <template v-slot:no-results>
                            <v-layout py-5>
                                <p>Ничего не найдено. <a @click="cleanFilters">Очистить фильтры</a></p>
                            </v-layout>
                        </template>
                        <template v-slot:headers="props">
                            <tr>
                                <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column text-xs-left',
                                                  pagination.descending ? 'desc' : 'asc',
                                                  header.sortable ? 'sortable' : '',
                                                  header.value === pagination.sortBy ? 'active' : '',
                                                  header.class ? header.class : ''
                                                ]"
                                    @click="header.sortable && changeSort(header.value)"
                                >
                                    {{ header.text }}
                                    <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :id="'listElement-' + props.item[0]"
                            >
                                <td>{{ props.item[1] || '—' }}</td>
                                <td>{{ props.item[2] }}</td>
                                <td>{{ props.item[8] }}</td>
                                <td>{{ props.item[3] }}</td>
                                <td>{{ props.item[4] || '—' }}</td>
                                <td>{{ props.item[5] || '—' }}</td>
                                <td v-if="showCurators">{{ props.item[6] || '—' }}</td>
                                <td v-if="showAgents">{{ props.item[7] || '—' }}</td>
                                <td v-if="showAgents">{{ props.item[13] || '—' }}</td>
                                <td v-if="showFileIcons">
                                    <v-icon v-if="props.item[12]" :color="props.item[9] ? '#00ba57' : 'red'">save</v-icon>
                                </td>
                                <td class="text-xs-right px-0">
                                    <v-menu v-if="props.item[10] || props.item[11]"
                                            :close-on-content-click="props.item[11]"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list v-if="props.item[10]">
                                            <v-list-tile>
                                                <v-list-tile-action class="justify-content-center">
                                                    <v-btn color="#00ba57" flat icon
                                                           :disabled="!props.selected"
                                                           @click="onUploadReceipt(props.item[0])">
                                                        <v-icon>file_upload</v-icon>
                                                    </v-btn>
                                                </v-list-tile-action>
                                                <v-list-tile-action class="justify-content-center">
                                                    <v-btn color="red" flat icon
                                                           :disabled="!props.selected"
                                                           @click="onClearReceiptFile(props.item[0], props)">
                                                        <v-icon>clear</v-icon>
                                                    </v-btn>
                                                </v-list-tile-action>
                                                <v-list-tile-action class="justify-content-center">
                                                    <v-btn color="#00ba57"
                                                           style="padding: 10px; max-width: 130px; text-overflow: ellipsis;"
                                                           round
                                                           depressed
                                                           dark
                                                           @click="onReceiptChoose(props.item[0])"
                                                    >Выбрать файл</v-btn>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                            <input
                                                v-show="false"
                                                :ref="'uploader' + props.item[0]"
                                                type="file"
                                                accept="image/jpg, image/jpeg, image/png"
                                                @change="onReceiptFileChanged($event, props.item[0], props)"
                                            >
                                        </v-list>
                                        <v-list v-if="props.item[11]">
                                            <v-list-tile @click="onDownloadReceipt(props.item[0])">
                                                <v-list-tile-title>Просмотреть чек</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:pageText="props">
                            {{ props.pageStart }} - {{ props.pageStop }} из {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import _ from "lodash";
import PayCommission from "../elements/PayCommission";

export default {
    components: {
        'b2b-pay-commission-dialog': PayCommission
    },
    props: {
        role: {
            default: null
        },
        type: {
            default: null
        },
        services: {
            default: []
        },
        list: {
            default: []
        },
        total: {
            default: 0
        }
    },

    data: () => ({
        filters: {
            tab: 0,
            search: '',
            service: null,
            curator: [],
            agent: [],
            period_from: null,
            period_to: null,
            sum_from: '',
            sum_to: ''
        },
        pagination: {
            descending: true,
            sortBy: '3',
            page: 1,
            rowsPerPage: 10,
            totalItems: 0
        },
        servicesList: [],
        curatorsList: [],
        agentsList: [],
        tabsList: ['Все', 'Выполненные', 'В обработке', 'Отклонённые', 'Ошибка'],
        tab: 0,

        headers: [],
        rows: [],
        totalRows: 0,
        selected: [],

        downloadFields: {},

        showCurators: false,
        showAgents: false,
        showFileIcons: false,
        isLoadingAgentsFilter: false,
        isLoadingCuratorsFilter: false,
        fileUploading: false,

        loading: false,
        loadingBalance: false,
        loadingUserBalance: false,
        init: false,

        balance: 0,
        userBalance: 0
    }),

    watch: {
        // TODO: пока что такая костыльная обработка постранички, пока не придумаю что-то более элегантное
        'pagination.descending': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.sortBy': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.page': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.rowsPerPage': {
            handler() {
                this.paginationHandle();
            }
        },
        'filters.tab': {
            handler() {
                this.paginationHandle();
            }
        },
        filters: {
            handler() {
                if (!this.init) {
                    return;
                }
                // TODO: для обработки доступности кнопки
                //console.log('I\'ll be watching you', this.filters);
            },
            deep: true
        },
    },

    computed: {
        isPhysical() {
            return this.type === Vue.GetpolisConstants.USER_TYPES.PHYSICAL;
        },
        isSoleProprietor() {
            return this.type === Vue.GetpolisConstants.USER_TYPES.SOLE_PROPRIETOR;
        },
        isSelfEmployed() {
            return this.type === Vue.GetpolisConstants.USER_TYPES.SELF_EMPLOYED;
        },
        isAdmin() {
            return this.role === Vue.GetpolisConstants.AGENT_TYPES.ADMIN;
        },
        isCurator() {
            return this.role === Vue.GetpolisConstants.AGENT_TYPES.CURATOR;
        },
        isAgent() {
            return this.role === Vue.GetpolisConstants.AGENT_TYPES.AGENT;
        },
        usersWithCommission() {
            return this.agentsList.filter(item => {return item.weekly_balance > 0;})
                .concat(this.curatorsList.filter(item => {return item.weekly_balance > 0;}))
                .sort(function (a, b) {return a.name > b.name ? 1 : -1;});
        }
    },

    created: function () {
        if (this.isAdmin) {
            this.showCurators = this.showAgents = this.showFileIcons = true;
        } else if (this.isCurator) {
            this.showAgents = this.showFileIcons = true;
        }
        if (this.isSelfEmployed) {
            this.showFileIcons = true;
        }

        this.servicesList = JSON.parse(window.atob(this.services));

        this.rows = JSON.parse(window.atob(this.list));
        this.totalRows = this.total;

        this.headers = [
            {text: 'Клиент', value: '1', width: 170, sortable: true},
            {text: 'Услуга', value: '2', width: 170},
            {text: 'Статус', value: '8'},
            {text: 'Дата', value: '3', sortable: true},
            {text: 'Приход', value: '4', sortable: true},
            {text: 'Расход', value: '5', sortable: true},
            {text: 'Куратор', value: '6'},
            {text: 'Пользователь', value: '7'},
            {text: 'Тип пользователя', value: '13'},
            {text: 'Файл', value: '9'},
            {text: '', value: '', class: 'px-0'},
        ];

        this.downloadFields = {
            '#': '0',
            'Клиент': '1',
            'Услуга': '2',
            'Статус': '8',
            'Дата': '3',
            'Приход': '4',
            'Расход': '5',
            'Куратор': '6',
            'Пользователь': '7',
            'Тип пользователя': '13',
            'Файл': '9',
        };

        if (!this.showCurators) {
            _.remove(this.headers, {text: 'Куратор'});
            delete this.downloadFields['Куратор'];
        }

        if (!this.showAgents) {
            _.remove(this.headers, {text: 'Пользователь'});
            delete this.downloadFields['Пользователь'];
            _.remove(this.headers, {text: 'Тип пользователя'});
            delete this.downloadFields['Тип пользователя'];
        }

        if (this.isAgent && !this.isSelfEmployed) {
            _.remove(this.headers, {text: 'Файл'});
        }

        this.searchCuratorsFilter();
        this.searchAgentsFilter();
        this.getBalance();
        this.getUserBalance();
        this.newSearch();

        this.init = true;
    },

    methods: {
        newSearch() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: this.pagination.rowsPerPage,
                f: JSON.stringify(this.filters)
            };
            this.loading = true;
            axios.post('/accounting-list', data)
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        this.rows = JSON.parse(window.atob(response.data.list));
                        this.totalRows = response.data.total;
                    } else {
                        PNotify.error('Возникли ошибки при поиске');
                        console.log(response);
                    }
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Возникли ошибки при поиске');
                })
                .finally(() => { this.loading = false; });
        },

        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },

        changeTab(index) {
            this.filters.tab = index;
            this.pagination.page = 1;
        },

        cleanFilters() {
            this.filters.search = '';
            this.filters.service = null;
            this.filters.curator = [];
            this.filters.agent = [];
            this.filters.period_from = null;
            this.filters.period_to = null;
            this.filters.sum_from = '';
            this.filters.sum_to = '';
            this.newSearch();
        },

        async downloadItems() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: -1,
                f: JSON.stringify(this.filters)
            };
            this.loading = true;
            let result = [];
            await axios.post('/accounting-list', data)
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        result = JSON.parse(window.atob(response.data.list));
                    } else {
                        PNotify.error('Возникли ошибки при формировании файла');
                        console.log(response);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Возникли ошибки при формировании файла');
                    this.loading = false;
                });

            return result;
        },

        paginationHandle() {
            if (!this.init) {
                return;
            }
            this.newSearch();
        },

        async searchAgentsFilter() {
            // Данные загружаются или уже получены
            if (this.isLoadingAgentsFilter || this.agentsList.length > 0) {
                return;
            }

            this.isLoadingAgentsFilter = true;

            axios.get('/agents-list-get').then(response => {
                this.agentsList = JSON.parse(window.atob(response.data));
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить список пользователей');
            }).finally(() => { this.isLoadingAgentsFilter = false; });
        },

        async searchCuratorsFilter() {
            // Данные загружаются или уже получены
            if (this.isLoadingCuratorsFilter || this.curatorsList.length > 0) {
                return;
            }

            this.isLoadingCuratorsFilter = true;

            axios.get('/curators-list-get').then(response => {
                this.curatorsList = JSON.parse(window.atob(response.data));
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить список кураторов');
            }).finally(() => { this.isLoadingCuratorsFilter = false; });
        },

        async getBalance() {
            if (this.loadingBalance) {
                return;
            }
            this.loadingBalance = true;
            axios.get('/accounting-balance').then(response => {
                if (response.data && response.data.status === 'ok') {
                    this.balance = response.data.sum;
                } else {
                    console.log(response);
                    PNotify.alert('Не удалось получить баланс');
                }
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить баланс');
            }).finally(() => { this.loadingBalance = false; });
        },

        async getUserBalance() {
            if (this.loadingUserBalance) {
                return;
            }
            this.loadingUserBalance = true;
            axios.get('/weekly-balance').then(response => {
                if (response.data && response.data.status === 'ok') {
                    this.userBalance = response.data.balance;
                } else {
                    console.log(error);
                    PNotify.alert('Не удалось получить баланс пользователя');
                }
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить баланс пользователя');
            }).finally(() => { this.loadingUserBalance = false; });
        },

        onPaymentCreated() {
            this.newSearch();
            this.getBalance();
            this.getUserBalance();
            this.searchAgentsFilter();
            this.searchCuratorsFilter();
        },

        onReceiptChoose(id) {
            this.$refs['uploader' + id].click();
        },

        onReceiptFileChanged(e, id, prop) {
            prop.selected = true;
        },

        onClearReceiptFile(id, prop) {
            let refInput = this.$refs['uploader' + id];
            refInput.parentNode.replaceChild(refInput.cloneNode(true), refInput);
            prop.selected = false;
        },

        onUploadReceipt(id) {
            if (this.fileUploading) {
                PNotify.alert('Уже производится активная загрузка');
                return;
            }
            this.fileUploading = true;
            const file = this.$refs['uploader' + id].files[0];
            let data = new FormData();
            data.append('file', file);
            axios.post('accounting/receipt/' + id, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(response => {
                if (response.data && response.data.status === 'ok') {
                    PNotify.success('Файл был загружен');
                } else {
                    console.log(response);
                    PNotify.error('Не удалось загрузить файл');
                }
            }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось загрузить файл');
            }).finally(() => { this.fileUploading = false; });
        },

        onDownloadReceipt(id) {
            window.location.href = '/accounting/receipt/' + id;
        }
    }
}
</script>
<style>
tr.not-read{
    background: #eee;
}
</style>

<style scoped>
.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    background-color: #00ba57 !important;;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0 5px;
    width: 100%;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    padding: 0 30px;
    line-height: 1.1;
}

.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

.agent-actions a {
    color: black;
    margin-right: 40px;
}

.agent-actions a img {
    margin-right: 5px;
    width: 21px;
    height: 21px;
    vertical-align: -5px;
}

.agent-actions a.disabled {
    color: grey;
}

.agent-actions a.disabled img {
    color: grey;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

/deep/ table.v-table tbody td,
/deep/ table.v-table thead th {
    font-size: 14px;
}

/deep/ table.v-table thead td:not(:nth-child(1)),
/deep/ table.v-table tbody td:not(:nth-child(1)),
/deep/ table.v-table thead th:not(:nth-child(1)),
/deep/ table.v-table tbody th:not(:nth-child(1)),
/deep/ table.v-table thead td:first-child,
/deep/ table.v-table tbody td:first-child,
/deep/ table.v-table thead th:first-child,
/deep/ table.v-table tbody th:first-child {
    padding: 0 5px;
}

.link {
    font-size: 14px;
    text-decoration: underline;
}

/deep/ .filters .v-input__slot,
/deep/ .filters .v-input__control,
/deep/ .filters .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

.wrappable {
    word-wrap: break-word;
    white-space: normal;
}

.justify-content-center {
    justify-content: center !important;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}
</style>

<style>
.remove-arrows input::-webkit-outer-spin-button,
.remove-arrows input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
}

.remove-arrows input[type=number] {
    -moz-appearance:textfield !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/AccountingList.vue